/**
 * hybrid 以及 browser 包使用此文件，将 invoke 定义和 bridge 包隔离，避免 browser 以及 hybrid 包必须引用 yoda 包 ts 定义问题。
 */

import { error } from './console';
import type { SetClientLogTypes } from '@/types/bridge';
import ssrGlobal from '@/util/ssr-global';

let invoke!: any;

export const isInYoda = () => {
    return typeof ssrGlobal?.__yodaBridge__?.invoke === 'function';
};

/**
 * 是否支持桥接 canIUse
 */
const isSupportBridge = async (name: string, namespace = 'tool') => {
    if (typeof invoke === 'undefined') return false;
    const res = await invoke('tool.canIUse', {
        namespace,
        name
    });
    return (res as any)?.canUse as boolean || false;
};

/**
 * 是否支持桥接上报埋点接口
 */
export const isSupportBridgeLog = () => {
    return isSupportBridge('setClientLog');
};

/**
 * 传入 invoke 方法
 */
export const postInvoke = (invokeOrYoda: any) => {
    if (typeof invokeOrYoda === 'function') {
        invoke = invokeOrYoda;
    } else {
        invoke = invokeOrYoda.invoke;
    }
};

/**
 * 发送业务事件
 */
export const setClientLog = async (type: SetClientLogTypes, data: unknown) => {
    try {
        return await invoke('tool.setClientLog', { type, data });
    } catch (err) {
        error(
            '[error 206]', `yoda.tool.setClientLog() 报错: ${(err as Error).message}`,
        );
    }
};

/**
 * 发送雷达事件
 */
export const sendRadarLog = async (params: any) => {
    try {
        return await invoke('tool.sendRadarLog', params);
    } catch (err) {
        error(
            '[error 207]', `yoda.tool.sendRadarLog() 报错: ${(err as Error).message}`,
        );
    }
};

/**
 * 发送web日志，支持日志回捞
 */
export const sendWebLog = async (params: any) => {
    try {
        return  invoke('tool.sendWebLog', params);
    } catch (err) {
        error(
            '[error 214]', `yoda.tool.sendWebLog() 报错: ${(err as Error).message}`,
        );
    }
};

/**
 * 发送汇总数据
 */
export const sendSummarizedLog = async (params: any) => {
    try {
        return await invoke('tool.sendSummarizedLog', params);
    } catch (err) {
        error(
            '[error 208]', `yoda.tool.sendSummarizedLog() 报错: ${(err as Error).message}`,
        );
    }
};

/**
 * 获取应用信息
 * @returns
 */
export const getAppInfo = async () => {
    try {
        return await invoke('system.getAppInfo');
    } catch (err) {
        error(
            '[error 209]', `yoda.system.getAppInfo() 报错: ${(err as Error).message}`,
        );
    }
};

/**
 * 获取 webview 信息
 */
export const getWebviewLoadPerf = async (params: any = {}, options: any) => {
    try {
        return await invoke('webview.getPageLoadData', params, options);
    } catch (err) {
        error(
            '[error 209]', `yoda.webview.getPageLoadData() 报错: ${(err as Error).message}`,
        );
    }
};

/**
 * 获取 webview 加载信息
 */
export const getWebviewInfo = async () => {
    try {
        return await invoke('webview.getLaunchParams');
    } catch (err) {
        error(
            '[error 209]', `yoda.webview.getPageLoadData() 报错: ${(err as Error).message}`,
        );
    }
};

/**
 * 获取 ksd相关webview 信息
 */
export const getKDSWebviewLoadPerf = async (params: any = {}) => {
    try {
        return await invoke('system.getPageLoadData', params);
    } catch (err) {
        error(
            '[error 209]', `yoda.system.getPageLoadData() 报错: ${(err as Error).message}`,
        );
    }
};

/**
 * 获取设备信息
 * @returns
 */
export const getDeviceInfo = async () => {
    try {
        return await invoke('system.getDeviceInfo');
    } catch (err) {
        error(
            '[error 209]', `yoda.system.getDeviceInfo() 报错: ${(err as Error).message}`,
        );
    }
};


export default {
    setClientLog,
    sendRadarLog,
    sendWebLog,
    sendSummarizedLog,
    getWebviewLoadPerf,
    getKDSWebviewLoadPerf,
    isSupportBridgeLog,
    isSupportBridge,
    invoke
};
